import { caseConverterClient } from "@/api/client"

export type SupportChatProvider = "pylon" | "intercom"
export type SupportChatEvent = "resolved" | "failed" | "opened"

// Records an in-app support chat outcome on the backend Prometheus counter so
// real per-provider usage and client-side load failures are chartable in
// Grafana. Fire-and-forget: telemetry must never surface to the user, so a
// failed beacon is swallowed (the failure path is also captured in Sentry by
// the caller).
export async function beaconSupportChatEvent(
  provider: SupportChatProvider,
  event: SupportChatEvent,
): Promise<void> {
  try {
    await caseConverterClient.post<void>("/api/support-chat/events", {
      provider,
      event,
    })
  } catch {
    // Intentionally ignored — see function doc.
  }
}
